module.exports = __webpack_public_path__ + "static/media/720p.b647d924.mp4";